<template>
  <a
    :href="operatorLink"
    :class="classes.link"
    target="_blank"
    @click="handleClick"
  >
    <img
      :src="operator.assetUrl"
      :alt="operator.name"
      :class="classes.image"
      @load="effectTrigger"
    />
  </a>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useBrand } from "../hooks/useBrand";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useBetData } from "../hooks/useBetData";
import { computed } from "vue";
import { useLayoutEffect } from "@fresh8/vue-utils/src/dimensionSync";
import { useHandleAnalytics } from "../lib/analytics";
import { AnalyticEvents } from "../types/analytics";

const useStyles = createUseStyles({
  link: {
    width: "100%"
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }
});

export default defineComponent({
  name: "OperatorLogo",
  setup() {
    const classes = useStyles();
    const { operator } = useBrand();
    const { links } = useBetData();
    const effectTrigger = useLayoutEffect();
    const $handleAnalytics = useHandleAnalytics();

    const handleClick = () => {
      const statsEvent = AnalyticEvents.CLICKED_THROUGH;
      const statsDesc = "Operator Logo";
      $handleAnalytics(statsEvent, statsDesc);
    };

    return {
      classes,
      operator,
      operatorLink: computed(() => links.value?.provider),
      effectTrigger,
      handleClick
    };
  }
});
</script>

<style></style>
